import { render, staticRenderFns } from "./MarkersTable.vue?vue&type=template&id=31106ba0"
import script from "./MarkersTable.vue?vue&type=script&lang=js"
export * from "./MarkersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports